// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6593bfdf","239":"fc64fe36","455":"65eccdb4"}[chunkId] + ".chunk.js";
};